import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import FieldAddressDadata from 'SharedComponents/DaData/FieldAddressDadata.vue';
import {
  BaseFieldEmits,
  defaultValuedProps,
  useBaseFieldProps,
  ValuedFieldProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFieldParams from 'SharedComponents/Fields/composables/useFieldParams';
import { useTooltip } from 'SharedComponents/Fields/composables/useFieldTooltip';
import FieldHistoryBtn from 'SharedComponents/Fields/FieldHistoryBtn.vue';
import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { AddressFieldParams, FieldValue } from 'SharedDir/declarations/fields';
import { computed } from 'vue';

type AddressFieldProps = ValuedFieldProps &
  PropValue<FieldValue<null | string>> & {
    params: AddressFieldParams;
  };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'AddressField' },
  __name: 'AddressField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    params: {}
  }, defaultValuedProps),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { validationRules } = useFieldParams(props);

const { innerValue, emitValue } = useValue(props, emit);

const tooltip = useTooltip(props);
const { hasHistory, revealHistory } = useBaseFieldProps(props, emit);

const bounds = computed(() => {
  const b = {} as { fromBound?: string; toBound?: string };

  if (props.params.fromBound) {
    b.fromBound = props.params.fromBound;
  }
  if (props.params.toBound) {
    b.toBound = props.params.toBound;
  }

  return b;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FieldAddressDadata, _mergeProps({
    ref: "input",
    modelValue: _unref(innerValue).value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).value) = $event)),
    class: { 's-form-input_wrapper': _ctx.useWrapper, required: _ctx.required },
    label: _ctx.label,
    readonly: _ctx.readonly,
    placeholder: _ctx.params.placeholder,
    "error-message": _ctx.errorMessage,
    "is-required": _ctx.required,
    rules: _unref(validationRules),
    "world-wide": ""
  }, bounds.value, { "onUpdate:modelValue": _unref(emitValue) }), _createSlots({ _: 2 }, [
    (_unref(tooltip) || (_ctx.showHistory && _unref(hasHistory)))
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            (_unref(tooltip))
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  text: _unref(tooltip)
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.showHistory && _unref(hasHistory))
              ? (_openBlock(), _createBlock(FieldHistoryBtn, {
                  key: 1,
                  history: _ctx.history,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(revealHistory)(_ctx.label)))
                }, null, 8, ["history"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue", "class", "label", "readonly", "placeholder", "error-message", "is-required", "rules", "onUpdate:modelValue"]))
}
}

})